import URL from '../api_url';

export const APPLICATION_PHASE_API = `${URL}/phase-application`;
